import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const Auth = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    user: {},
    status: null,
  },
  getters: {
    isAuthenticated: state => (state.token ? true : false),
    userName: state => (state.user ? state.user.name : null),
    userEmail: state => (state.user ? state.user.email : null),
    token: state => state.token || null,
    status: state => state.status,
    userId: state => state.user.id || null,
    profile: state => state.user || {}
  },
  mutations: {
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
      localStorage.setItem("token", token);
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.token = "";
      state.user = {};
      state.status = null;
      localStorage.removeItem("token");
      delete axios.defaults.headers.common['Authorization']
    },
    set_user(state, user) {
      state.user = user;
    }
  },
  actions: {
    login({ commit, dispatch }, credentials) {
      return new Promise((resolve, reject) => {
        // axios
        //   .get(config.API_URL + "sanctum/csrf-cookie")
        //   .then(() => {
        axios
          .post(
            config.API_URL + '/login',
            {
              ...credentials
            }
          )
          .then(res => {
            let token = res.data;
            commit("auth_success", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            dispatch('getUser');
            resolve();
          })
          .catch(err => {
            //console.log(err);
            commit("auth_error");
            commit('logout');
            reject(err);
          });
        // })
        // .catch(err => {
        //   console.log(err);
        //   reject();
        // });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(config.API_URL + '/logout')
          .then(() => {

            resolve();
          })
          .catch(error => {
            //console.log(error);
            reject(error);
          }).then(() => {
            localStorage.clear();
            commit("logout");
          })
      });
    },
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(config.API_URL + '/user')
          .then(response => {
            //console.log(response);
            commit("set_user", response.data);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateUser({ state, commit }, user) {
      return new Promise((resolve, reject) => {
        axios
          .put(config.API_URL + '/user', { ...user })
          .then(response => {
            //console.log(response.data);
            commit('set_user', response.data);
            resolve(response.data)
          })
          .catch(error => { reject(error) })
      });
    },

    validatePassword({ }, password) {
      return new Promise((resolve, reject) => {
        axios
          .post(config.API_URL + '/user/validate', { password })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => { reject(error) })
      });
    },

    changePassword({ }, passwords) {
      return new Promise((resolve, reject) => {
        axios
          .put(config.API_URL + '/user/password', { ...passwords })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => { reject(error) })
      });
    }
  }
};

export default Auth;
